import React from "react";

/** โลโก้ย่อ: รูปโลโก้ของร้าน (ถ้ามี) ไม่งั้นตัวอักษรย่อ — brand มาจาก brandingOf()/useBranding() */
export default function BrandMark({ brand, size, style }) {
  const box = size ? { width: size, height: size, fontSize: Math.round(size * 0.4) } : {};
  if (brand?.custom && brand.logo) {
    return (
      <span className="crm-logo is-image" style={{ ...box, ...style }}>
        <img src={brand.logo} alt={brand.name} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
      </span>
    );
  }
  return (
    <span className="crm-logo" style={{ ...box, ...style }}>
      {brand?.shortName || "LU"}
    </span>
  );
}
